import { getCircular } from '../Service/Api'; 
import React, { useState,useEffect } from 'react';
import Header from "../Component/Header";
import { Link } from 'react-router-dom' 
import SportsActivitiesData from'./SportsActivitiesData'
const SportActivites = () => {
    useEffect(() => {
        document.title = 'Sport Activites-  The Air Force School Subroto Park';  
    }, []);   
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState(); // Default to "All"
    const [yearRanges, setYearRanges] = useState([]);
    useEffect(() => {
        const currentYear = new Date().getFullYear();
        setSelectedYear(`${currentYear}`);
      }, []);
    // Fetch data on initial render
    useEffect(() => {
        const fetchData = async () => {
            const galleryData1 = await getCircular();
            const galleryData = galleryData1.filter(item => item.category === 'SportActivites');
            setData(galleryData);

            // Extract unique years
            const uniqueYears = Array.from(
                new Set(galleryData.flatMap((item) => {
                    if (item.date) {
                        const year = new Date(item.date).getFullYear(); // Extract only the year
                        return [year];
                    } else {
                        return [];
                    }
                }))
            );

            // Prepare year range and sort
            const uniqueYearRanges = uniqueYears.map(year => `${year}`).sort((a, b) => b - a);
            setYearRanges(uniqueYearRanges);
        };
        fetchData();
    }, []);

    // Filter data when the year changes or data is fetched
    useEffect(() => {
        let filteredData = data;
        if (selectedYear !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date) {
                    const year = new Date(item.date).getFullYear();
                    return parseInt(selectedYear) === year;
                } else {
                    return false;
                }
            });
        }
        setFilteredData(filteredData);
    }, [selectedYear, data]);
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>  
                 <li>Sports Activites </li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container"> 
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Sports Activites  </h1>
                    </div>
                </div> 
                <div className="row">
                <div className="col-lg-12">
                <div className="chooseyear">
                <select id="chooseddlYear"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    className="yearSelection"
                >
                    <option value={"All"}>All</option>
                    
                    {yearRanges.map((yr) => (
                        <option key={yr} value={yr}>{yr}</option>
                    ))}
                    <option value="Archive">Archive</option>
                </select>
               
            </div>
            <div className="clr"></div>
            <div className="row achievementlist">
            <ul className="list"> 
            {filterData.length > 0 ? (filterData?.filter((item) => item.category === "SportActivites").map((item, index) =>  ( 
                
                    <li key={index}><Link to={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank"><div dangerouslySetInnerHTML={{ __html:item.title}} /> - <b>Click Here</b></Link></li>
               
           )) ): (
            <p> </p>
           )} 

           </ul> 
            </div>

            {selectedYear === 'Archive' && (
                <SportsActivitiesData/>
            )}
                  </div>
                  </div>
                      
             
            </div>
        </div>
     </>
  )
}

export default SportActivites